module.exports = __webpack_public_path__ + "static/media/wxwork.15a8981a.svg";